// BillingHistory.js
import React from 'react'
import moment from 'moment'

export default function BillingHistory ({ invoices }) {
  const list = Array.isArray(invoices) ? invoices : []
  return (
    <>
      <h5 style={{ marginBottom: 12 }}>Billing history</h5>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
        <thead>
          <tr style={{ textAlign: 'left', color: '#6b7280' }}>
            <th style={{ padding: '6px 8px', borderBottom: '1px solid #e5e7eb' }}>Date</th>
            <th style={{ padding: '6px 8px', borderBottom: '1px solid #e5e7eb' }}>Amount</th>
            <th style={{ padding: '6px 8px', borderBottom: '1px solid #e5e7eb' }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {list.length === 0 && (
            <tr>
              <td colSpan='3' style={{ padding: '12px 8px', textAlign: 'center', color: '#9ca3af' }}>
                No invoices yet
              </td>
            </tr>
          )}
          {list.map(inv => (
            <tr key={inv.id}>
              <td style={{ padding: '6px 8px', borderBottom: '1px solid #f3f4f6' }}>{moment(inv.created * 1000).format('YYYY-MM-DD')}</td>
              <td style={{ padding: '6px 8px', borderBottom: '1px solid #f3f4f6' }}>${((inv.amount_paid || 0) / 100).toFixed(2)}</td>
              <td style={{ padding: '6px 8px', borderBottom: '1px solid #f3f4f6' }}>{inv.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
}
